import { AVATAR_ICONS, AVATAR_STATE } from './constants';
const getStateIcon = (state) => {
    if (!state || state === AVATAR_STATE.deceased) {
        return null;
    }
    return AVATAR_ICONS[state] || null;
};
export { getStateIcon };
//# sourceMappingURL=utils.js.map